import type { FC } from 'react';

import { DateRenderer, DateTimeRenderer } from '@/components/UI/DateRenderers/DateRenderers';
import { _isNotBlank, _isNotEmpty, _notNil } from '@/littledash';
import type { Study, StudyMetrics } from '@/model/Study.model';
import { typeToTextMap } from '@/referenceData/study/type';

import SummaryItem from '../SummaryItem';

interface InformationCardProps {
  study: Study;
  metrics?: StudyMetrics;
  benchlingFolderName: string | null;
}

const InformationCard: FC<InformationCardProps> = ({ study, metrics, benchlingFolderName }) => {
  const author = study.author;
  const owner = study.owner;

  return (
    <div className="ui-card pa3" data-testid="overview-information">
      <div className="flex flex-row mb3">
        <div className="w-50">
          {_notNil(author) && <SummaryItem label="Author">{author.name}</SummaryItem>}
          {_notNil(owner) && <SummaryItem label="Owner">{owner.name}</SummaryItem>}
          <SummaryItem label="Date created">
            <DateTimeRenderer value={study.created_at} defaultResponse="-" />
          </SummaryItem>
          <SummaryItem label="Preset">{study.settings.title}</SummaryItem>
          <SummaryItem label="Type">{typeToTextMap[study.type]}</SummaryItem>
          {_isNotBlank(benchlingFolderName) && (
            <SummaryItem label="Benchling Folder">{benchlingFolderName}</SummaryItem>
          )}
        </div>
        <div className="w-50">
          <SummaryItem label="Animals">{metrics?.counts.active_animals ?? '-'}</SummaryItem>
          <SummaryItem label="Cages">{metrics?.counts.cages ?? '-'}</SummaryItem>
          <SummaryItem label="Groups">{metrics?.counts.study_groups ?? '-'}</SummaryItem>
          <SummaryItem label="Start date">
            <DateRenderer value={study.started_on} defaultResponse="-" />
          </SummaryItem>
        </div>
      </div>
      {_isNotEmpty(study.notes) && (
        <div className="flex flex-row mb3">
          <div className="w-100">
            <div className="lh-copy">
              <div className="flex flex-row ph3 pv2 f6">
                <div style={{ width: 150, minWidth: 150 }}>Description</div>
                <p className="near-black f6">{study.notes}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InformationCard;
